export function validateToySpec(spec) {
  const warnings = []
  if (!spec || typeof spec !== 'object') return { ok: false, warnings: ['spec missing'] }
  const required = ['dataContract','visualization','layering','clipping','axis','interactions','parameters','updatePolicy']
  for (const k of required) if (!(k in spec)) warnings.push(`missing ${k}`)
  if (spec.dataContract?.type !== 'series' && spec.dataContract?.type !== 'datasets') warnings.push('dataContract.type invalid')
  if (!Array.isArray(spec.layering) || spec.layering.length === 0) warnings.push('layering invalid')
  if (typeof spec.clipping !== 'boolean') warnings.push('clipping invalid')
  if (!spec.axis || typeof spec.axis !== 'object') warnings.push('axis invalid')
  if (!spec.interactions || typeof spec.interactions !== 'object') warnings.push('interactions invalid')
  const ok = warnings.length === 0
  return { ok, warnings }
}

/**
 * 验证Toy配置中的日期字段
 * @param {Object} config - Toy配置对象
 * @returns {Object} { ok: boolean, warnings: string[] }
 */
export function validateToyDates(config) {
  const warnings = []
  
  // 检查createdAt是否存在且格式正确
  if (!config.createdAt) {
    warnings.push('createdAt is missing')
  } else if (!/^\d{4}-\d{2}-\d{2}$/.test(config.createdAt)) {
    warnings.push('createdAt format should be YYYY-MM-DD')
  }
  
  // 检查updatedAt是否存在且格式正确
  if (!config.updatedAt) {
    warnings.push('updatedAt is missing')
  } else if (!/^\d{4}-\d{2}-\d{2}$/.test(config.updatedAt)) {
    warnings.push('updatedAt format should be YYYY-MM-DD')
  }
  
  // 检查日期不能是过去的日期（比项目启动日期2024-01-01更早）
  const minValidDate = new Date('2024-01-01')
  if (config.createdAt) {
    const createdAt = new Date(config.createdAt)
    if (createdAt < minValidDate) {
      warnings.push(`createdAt ${config.createdAt} is too old, should not be earlier than 2024-01-01`)
    }
  }
  
  if (config.updatedAt) {
    const updatedAt = new Date(config.updatedAt)
    if (updatedAt < minValidDate) {
      warnings.push(`updatedAt ${config.updatedAt} is too old, should not be earlier than 2024-01-01`)
    }
  }
  
  // 检查updatedAt不能早于createdAt
  if (config.createdAt && config.updatedAt) {
    if (new Date(config.updatedAt) < new Date(config.createdAt)) {
      warnings.push('updatedAt cannot be earlier than createdAt')
    }
  }
  
  const ok = warnings.length === 0
  return { ok, warnings }
}
